<template>
  <div>
    <wc-dialog
      :showDialog='showDialog'
      :loading='areClientsLoading'
      :title='title'
      :icon='$store.state.icons.dataBox.invoices.icon'
      iconColor='success'
      :loadingButtons='isSavingNewInvoice || isLoading || areClientsLoading'
      :disableButtons='!isFormValid'
      @cancel="$emit('cancel')"
      @save='generateInvoice'
      saveText='Create Invoice'
      width='350'
    >
      <br>
      <v-form v-model='isFormValid' ref='form'>
        <v-select
          v-if='!hideDivision'
          :items='$store.state.misc.divisions'
          item-value='id'
          item-text='division'
          label='Division'
          v-model='newInvoice.division'
          :rules='[rules.required]'
        ></v-select>
        <wc-datepicker
          label='Invoice date'
          required
          v-model='newInvoice.invoice_date'
        ></wc-datepicker>

        <client-form-search
          v-model='newInvoice.bill_to'
          label='Bill to'
          @loading='setLoading'
        ></client-form-search>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>

import formRules from '@/mixins/formRules';
import accountingAPI from '@/api/accounting';
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch';
import _ from 'lodash';

export default {
  name: 'new-invoice-dialog',
  mixins: [formRules],
  props: {
    invoice: {
      required: true
    },
    showDialog: {
      required: true
    },
    title: {
      required: false,
      type: String,
      default: 'New Invoice'
    },
    hideDivision: {
      required: false,
      type: Boolean,
      default: false
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false,
    },
    generateInvoiceOnSave: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isFormValid: false,
    isSavingNewInvoice: false,
    areClientsLoading: false,
    newInvoice: {}
  }),
  watch: {
    showDialog () {
      if (this.showDialog === true) {
        this.setupInvoice()
      }
    }
  },
  methods: {
    setupInvoice () {
      this.newInvoice = _.cloneDeep(this.invoice)
      setTimeout(() => {
        this.$refs.form.resetValidation()
      }, 100)
    },
    async generateInvoice () {
      this.isSavingNewInvoice = true
      if (this.generateInvoiceOnSave) {
        let inv = await accountingAPI.createInvoice(this.newInvoice)
        this.$emit('save', inv)
      } else {
        this.$emit('save', this.newInvoice)
      }
      this.isSavingNewInvoice = false
    },
    setLoading (val) {
      this.areClientsLoading = val
    }
  },
  components: {
    'client-form-search': ClientFormSearch
  }
}
</script>
